import { render, staticRenderFns } from "./OnboardItem.vue?vue&type=template&id=171b3bc0&"
import script from "./OnboardItem.vue?vue&type=script&lang=js&"
export * from "./OnboardItem.vue?vue&type=script&lang=js&"
import style0 from "./OnboardItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports